// @flow

// color naming is based on ant design color model -
// https://ant.design/docs/spec/colorSet#Color-Model
const colorSet = {
    // brand color
    rhino: '#25354e',
    blueWood: '#31425c',
    bay: '#3c5070',
    southern: '#01689a',
    arctic: '#00a7e1',
    fog: '#f0f2f5',

    // OOS custom colors
    earlsGreen: '#c1b520',
    java: '#2aa69d',
    mediumPurple: '#906fdd',

    //main color for text
    textGray9: 'rgba(0, 0, 0, 0.85)',
    textGray8: 'rgba(0, 0, 0, 0.65)',
    textGray7: 'rgba(0, 0, 0, 0.45)',
    textGray6: 'rgba(0, 0, 0, 0.25)',

    //main colors
    black: '#000000',
    white: '#ffffff',
    transparent: 'rgba(0,0,0,0)',
    gray9: '#262626',
    gray8: '#595959',
    gray7: '#8c8c8c',
    gray6: '#bfbfbf',
    gray5: '#d9d9d9',
    gray4: '#e8e8e8',
    gray3: '#f5f5f5',
    gray2: '#fafafa',
    red6: '#f5222d',
    red3: '#ffa39e',
    red1: '#fff1f0',
    gold6: '#faad14',
    gold3: '#ffe58f',
    gold1: '#fffbe6',
    blue10: '#002766',
    blue6: '#00a7e1',
    blue3: '#91d5ff',
    blue1: '#e6f7ff',
    blue11: '#037eda',

    green7: 'rgb(42, 166, 157)',
    green6: '#52c41a',
    green3: '#b7eb8f',
    green1: '#f6ffed',

    //vessel colors
    bulkCarrier: '#a57157',
    oreCarrier: '#a57157',
    pctc: '#4a8Ca3',
    container: '#70a787',
    chemical: '#e47683',
    lpgCarrier: '#f5b397',
    oilCrude: '#6e71c0',
    oilProduct: '#bf6c92',
    yacht: '#917a85'
};

const chartsColors = Object.freeze({
    chartBlue1: colorSet.arctic,
    chartBlue2: colorSet.southern,
    chartBlue3: colorSet.bay,
    chartBlue4: '#60c5e9',
    chartBlue5: '#619fbe',
    chartBlue6: '#8491a5',
    chartBlue7: '#a8dbef',
    chartPurple10: '#a500e1',
    chartPurple14: '#c361e9',
    chartPurple18: '#daa9ef',
    chartPink11: '#e100c7',
    chartPink15: '#e761d9',
    chartPink19: '#eca9e7',
    chartYellow12: '#f3b004',
    chartYellow16: '#f2cb64',
    chartYellow20: '#f1deac',
    chartOrange13: '#f18206',
    chartOrange17: '#f1af66',
    chartOrange21: '#f0d0ad',
    chartPositive1: colorSet.green6,
    chartPositive2: '#91d772',
    chartPositive3: '#c1e4b3',
    chartNegative1: colorSet.red6,
    chartNegative2: '#f3757d',
    chartNegative3: '#f2b3b9'
});

const colors = {
    ...colorSet,
    ...chartsColors,

    success: colorSet.green6,
    successBorder: colorSet.green3,
    successBackground: colorSet.green1,

    warning: colorSet.gold6,
    warningBorder: colorSet.gold3,
    warningBackground: colorSet.gold1,

    info: colorSet.blue6,
    infoBorder: colorSet.blue3,
    infoBackground: colorSet.blue1,

    error: colorSet.red6,
    errorBorder: colorSet.red3,
    errorBackground: colorSet.red1,

    tableRowLabel: colorSet.textGray9,
    headerText: colorSet.textGray9,

    mainText: colorSet.textGray8,

    caption: colorSet.textGray7,

    disabled: colorSet.gray6,
    disabledText: colorSet.textGray6,

    disabledDark: colorSet.gray5,
    borderDark: colorSet.gray5,
    footerText: colorSet.gray5,

    borderLight: colorSet.gray4,

    tableRowBackground: colorSet.gray2
};

export default colors;
